var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabs',[_c('TabPane',{attrs:{"label":"任务详情"}},[_c(_vm.componentName,{tag:"component",attrs:{"id":_vm.relateId,"task":_vm.task}})],1),_c('TabPane',{attrs:{"label":"任务进度"}},[_c('history',{ref:"ApprovalHistory",attrs:{"relate-id":_vm.relateId,"type":'cancel'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }